import { Reveal } from "./Reveal";
import { IMAGES } from "../../lib/content";

export default function Lifestyle() {
  return (
    <section
      data-testid="lifestyle"
      className="relative bg-[#050505] py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-8 items-stretch">
          <div className="lg:col-span-5 flex flex-col justify-center">
            <Reveal>
              <span className="text-xs tracking-luxe uppercase text-[#d4af37]">
                Conscious Living
              </span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif-lux text-4xl md:text-6xl mt-6 leading-[1.03] text-[#f5f5f0]">
                Happier people,
                <br />
                <span className="italic gold-gradient-text">by design.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 text-[#9a968c] leading-relaxed max-w-md">
                Sarrgosa is more than an address — it is a community of people
                who chose clarity over clutter. Shared gardens, unhurried
                mornings and neighbours who become family. This is what
                conscious luxury feels like.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <div className="mt-10 flex gap-10">
                <div>
                  <p className="font-serif-lux text-5xl gold-gradient-text">
                    72%
                  </p>
                  <p className="mt-2 text-xs tracking-[0.14em] uppercase text-[#9a968c]">
                    Open green space
                  </p>
                </div>
                <div>
                  <p className="font-serif-lux text-5xl gold-gradient-text">
                    100%
                  </p>
                  <p className="mt-2 text-xs tracking-[0.14em] uppercase text-[#9a968c]">
                    Homes with a view
                  </p>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 gap-5">
            <Reveal className="row-span-2">
              <div className="gold-border p-2 h-full">
                <img
                  src={IMAGES.familyPath}
                  alt="A family walking a mountain trail at Sarrgosa"
                  className="w-full h-full min-h-[300px] object-cover spotlight"
                />
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="gold-border p-2">
                <img
                  src={IMAGES.onebhkLiving}
                  alt="1 BHK living room opening to a balcony over the hills"
                  className="w-full h-[190px] object-cover spotlight"
                />
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="gold-border p-2">
                <img
                  src={IMAGES.interiorNook}
                  alt="A quiet reading nook framing the sunrise hills"
                  className="w-full h-[190px] object-cover spotlight"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
